<div class="scc-upload-confirmed-content">
  <p class="confirmation-message">
    Vous venez de déposer une demande de dépistage.
    <b>Vous trouverez la facture correspondant à votre règlement, directement dans votre compte Lofvet.</b>
    En parallèle vous recevrez un mail de ce type (cf copie d'écran), correspondant à ce règlement.
    Merci de votre confiance.
  </p>
  
  <p class="billing-info">
    La facturation des études est déclenchée au début du mois suivant le dépôt.
    La facture pourra être annulée seulement si l'étude est annulée avant cette date,
    et qu'aucune lecture n'a encore été faite.
  </p>

  <div class="email-example">
    <img src="/assets/img/scc/bill-confirmation-example.png" alt="Exemple de facture de confirmation" class="bill-example-image">
  </div>
</div>
